
const API_URL = "https://api.thecoverkraft.com/"; //--------uat------

//
// const API_URL = "https://devapi.thecoverkraft.com/"; //--------dev------

//const API_URL = "http://52.52.154.65:5242/";
//const API_URL = 'http://192.168.1.17:5242/'; //harshita mam ip
//const API_URL = 'http://192.168.29.57:5242/'; // For local development
export default API_URL;
